var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-header"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.handleLogo())}})])
}
var staticRenderFns = []

export { render, staticRenderFns }